<template lang="pug">      
  nt-dialog(
    v-model='dialog'
    title="รูปแบบการเล่น"
    max-width="600"
    scrollable
  )
    div.game-format
      div.game--item
        div(@click="onSelect(MOBILE)").game--content
          v-img(width='80', src='@/assets/icon/mobile-phone.svg')
          span MOBILE
      div.game--item
        div(@click="onSelect(DESKTOP)").game--content
          v-img(width='80', src='@/assets/icon/desktop.svg')
          span DESKTOP
</template>
<script>
const MOBILE = 'mobile'
const DESKTOP = 'desktop'

export default {
  components : {
  },

  data: () => ({ 
    dialog: false, 
  }),

  computed: {
    MOBILE: () => MOBILE,
    DESKTOP: () => DESKTOP,
  },

  methods : {
    open () {
      this.dialog = true
    },
    close () {
      this.dialog = false
    },
    onSelect (value) {
      this.$emit('select', value)
      this.close()
    }
  }
}
</script>
<style scoped>
.game-format {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: 1fr;
  gap: 20px;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 12px;
  padding-bottom: 12px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.game--item {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.game--content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  max-width: 160px;
  border: solid 1px;
  border-radius: .5em;
  padding: 8px;
  gap: 8px;
  cursor: pointer;
}
</style>